const path = `api/v1`
const urlAuth = process.env.VUE_APP_URL_API + path
const hostApi = process.env.VUE_APP_URL_API + path
const hostBackend = process.env.VUE_APP_URL_BACKEND
const urlApi = {
    auth:{
        login: urlAuth + `/auth/login`,
        forgot_password : urlAuth +`/auth/forgot-password`,
        change_password : urlAuth +`/auth/challenge`,
        all_role : urlAuth + `/auth/all-role`
    },
    time_recording: {
        list_request: hostApi + `/time-recording/list`,
        get_data:hostApi  +`/time-recording`,
        add_data:hostApi + `/time-recording`,
        update_data:hostApi + `/time-recording`,
        delete_data:hostApi + `/time-recording`,
        submit_data:hostApi + `/time-recording/submit`,
        approval:hostApi + `/time-recording/approval`,
        detail:hostApi + `/time-recording/detail`
    },
    project:{
        combo:hostApi + `/project/list`,
        projectAll : hostApi + `/project/all`,
        in_progress:hostApi + `/project/in-progress`
    },
    leave_request:{
        get_data:hostApi + `/leave-request`,
        leave_type_list:hostApi +`/leave-type/list`,
        add:hostApi + `/leave-request`,
        update:hostApi + `/leave-request`,
        delete:hostApi + `/leave-request`,
        effective_date: hostApi + `/leave-request/effective-date`,
        detail:hostApi + `/leave-request/detail`,
        approval:hostApi + `/leave-request/approval`,
        status:hostApi + `/leave-request/status`,
        leave_quota:hostApi + `/leave-request/leave-quota`,
        detail_leave_by_code : hostApi + `/leave-type/detail-leave-by-code`
    },
    contact:{
        list:hostApi +`/contact/list`
    },
    news:{
        get:hostApi + `/news/list`,
        detail:hostApi + `/news/detail`,
        career:hostApi + `/news/career`,
        career_detail:hostApi + `/news/detail`,
        related_articles:hostApi + `/news/related-articles`,
        list_attachment:hostApi + `/news/list-attachment`
    },
    events:{
        get:hostApi + `/event/list`,
        detail:hostApi + `/event/detail`,
        related_articles:hostApi + `/event/related-articles`,
        list_attachment:hostApi + `/event/list-attachment`
    },
    cash_advance:{
        get:hostApi + `/cash-advance`,
        add:hostApi + `/cash-advance`,
        update:hostApi + `/cash-advance`,
        detail:hostApi + `/cash-advance/detail`,
        delete:hostApi + `/cash-advance`,
        approval:hostApi + `/cash-advance/approval`,
        status:hostApi + `/cash-advance/status`
    },
    employee:{
        detail:hostApi + `/employee/detail`,
        activities:hostApi + `/employee/activities`,
        new_employee:hostApi + `/employee/new`,
        off:hostApi + `/employee/off`,
        list_supervisor : hostApi + `/employee/list-supervisor`,
        update_avatar: hostApi + `/employee/change-avatar`
    },
    currency:{
        list : hostApi + `/currency/list`
    },
    identity:{
        index: hostApi + `/identity`,
        add: hostApi + `/identity`,
        update: hostApi + `/identity`,
        delete: hostApi + `/identity`,
        type: hostApi +'/identity/type'
    },
    driving_license:{
        index : hostApi + `/driving-license`,
        add : hostApi + `/driving-license`,
        update : hostApi + `/driving-license`,
        delete : hostApi + `/driving-license`,
        license_type:hostApi + `/driving-license/type`
    },
    tax_payer:{
        index : hostApi + `/npwp`,
        add : hostApi + `/npwp`,
        update : hostApi + `/npwp`,
        delete : hostApi + `/npwp`,
    },
    passport:{
        index: hostApi +`/passport`,
        type: hostApi + `/passport/passport-type`,
        add:hostApi + `/passport`,
        update:hostApi + `/passport`,
        delete:hostApi + `/passport`,
    },
    country:{
        list:hostApi + `/country/list`,
        nationality: {
            list: hostApi + `/country/nationality`
        },
        detail:hostApi + `/country/detail`
    },
    bpjs_kesehatan:{
        index:hostApi +`/health-insurance`,
        add:hostApi +`/health-insurance`,
        update:hostApi +`/health-insurance`,
        delete:hostApi +`/health-insurance`,
    },
    bpjs_ketenagakerjaan:{
        index:hostApi + `/jamsostek`,
        add:hostApi + `/jamsostek`,
        update:hostApi + `/jamsostek`,
        delete:hostApi + `/jamsostek`,
    },
    contract_classification:{
        index: hostApi + `/contract-classification`,
        add: hostApi + `/contract-classification`,
        update: hostApi + `/contract-classification`,
        delete: hostApi + `/contract-classification`,
        detail: hostApi + `/contract-classification/detail`,
    },
    contract_status:{
        index:hostApi + `/contract-status`,
        add:hostApi + `/contract-status`,
        delete:hostApi + `/contract-status`,
        update:hostApi + `/contract-status`,
    },
    job_title:{
        index:hostApi + `/job-title`,
        add:hostApi + `/job-title`,
        delete:hostApi + `/job-title`,
        update:hostApi + `/job-title`,
    },
    duty_station:{
        index:hostApi + `/duty-station`,
        add:hostApi + `/duty-station`,
        delete:hostApi + `/duty-station`,
        update:hostApi + `/duty-station`,
    },
    grade:{
        index:hostApi + `/grade`,
        add:hostApi + `/grade`,
        delete:hostApi + `/grade`,
        update:hostApi + `/grade`,
    },
    address:{
        index:hostApi + `/address`,
        add:hostApi + `/address`,
        delete:hostApi + `/address`,
        update:hostApi + `/address`,
        type:hostApi + `/address/type`
    },
    state:{
        combo:hostApi + `/state/combo`
    },
    city:{
        combo:hostApi + `/city/combo`,
        sub_district:{
            combo:hostApi + `/city/sub-district/combo`
        }
    },
    phone:{
        index:hostApi + `/phone`,
        add:hostApi + `/phone`,
        delete:hostApi + `/phone`,
        update:hostApi + `/phone`,
        type:hostApi + `/phone/type/combo`
    },
    email:{
        index:hostApi + `/email`,
        add:hostApi + `/email`,
        delete:hostApi + `/email`,
        update:hostApi + `/email`,
        type:hostApi + `/email/type/combo`
    },
    emergency_contact:{
        index:hostApi + `/emergency-contact`,
        add:hostApi + `/emergency-contact`,
        delete:hostApi + `/emergency-contact`,
        update:hostApi + `/emergency-contact`,
        type:hostApi + `/emergency-contact/type/combo`
    },
    family:{
        index:hostApi + `/family`,
        add:hostApi + `/family`,
        delete:hostApi + `/family`,
        update:hostApi + `/family`,
        detail:hostApi + `/family/detail`
    },
    reference:{
        relationship_type: hostApi + `/reference/relationship-type`,
        relationship_status: hostApi + `/reference/relationship-status`,
        salutation: hostApi + `/reference/salutation`,
        religion: hostApi + `/reference/religion`,
        blood_type: hostApi + `/reference/blood-type`,
        payment_method: hostApi + `/reference/payment-method`,
        purpose: hostApi + `/reference/purpose`,
        staff_request_type: hostApi + `/reference/staff-request-type`,
        setting_value: hostApi + `/reference/setting-value`,
        unit: hostApi + `/reference/list-unit`,
        department: hostApi + `/reference/list-department`,
    },
    wfh:{
        index:hostApi + `/work-from-home`,
        detail:hostApi + `/work-from-home/detail`,
        add:hostApi + `/work-from-home`,
        update:hostApi + `/work-from-home`,
        delete:hostApi + `/work-from-home`,
        status:hostApi + `/work-from-home/status`,
        approval:hostApi + `/work-from-home/approval`,
    },
    compensatory:{
        index:hostApi + `/compensatory`,
        add:hostApi + `/compensatory`,
        update:hostApi + `/compensatory`,
        delete:hostApi + `/compensatory`,
        detail:hostApi + `/compensatory/detail`,
        status:hostApi + `/compensatory/status`,
        approval:hostApi + `/compensatory/approval`,
    },
    compensatory_overtime:{
        index:hostApi + `/compensatory-overtime`,
        add:hostApi + `/compensatory-overtime`,
        update:hostApi + `/compensatory-overtime`,
        delete:hostApi + `/compensatory-overtime`,
        detail:hostApi + `/compensatory-overtime/detail`,
        status:hostApi + `/compensatory-overtime/status`,
        approval:hostApi + `/compensatory-overtime/approval`,
    },
    travel_request:{
        index:hostApi + `/travel-request`,
        add:hostApi + `/travel-request`,
        update:hostApi + `/travel-request`,
        delete:hostApi + `/travel-request`,
        detail:hostApi + `/travel-request/detail`,
        approval:hostApi + `/travel-request/approval`,
        status:hostApi + `/travel-request/status`,
    },
    staff:{
        index:hostApi + `/staff`,
        add:hostApi + `/staff`,
        update:hostApi + `/staff`,
        delete:hostApi + `/staff`,
        detail:hostApi + `/staff/detail`,
        status:hostApi + `/staff/status`,
        approval:hostApi + `/staff/approval`,
    },
    intranet:{
        policy_regulation:hostApi + `/intranet/policy-regulation`,
        list_policy_regulation:hostApi + `/intranet/list/policy-regulation`,
        list_policy_regulation_file:hostApi + `/intranet/list/policy-regulation/file`,
        download:hostBackend + `/files/cms/`,
        download_picture:hostBackend + `/files/cms/`,
        list_picture_album:hostApi + `/intranet/list/picture-album`,
        list_picture:hostApi + `/intranet/list/picture-gallery`,
        list_video_group:hostApi + `/intranet/list/video-group`,
        list_video:hostApi + `/intranet/list/video-gallery`,
        path_video:hostBackend + `/files/cms/`,
        contact_list:hostApi + `/intranet/contact-list`,
        contact_detail:hostApi + `/intranet/contact-detail`,
    },
    notification:{
        list: hostApi + `/notifications/list`,
        list_todo: hostApi + `/notifications/list-todo`,
        completed: hostApi + `/notifications/completed`,
        read_message: hostApi + `/notifications/read-message`,
        detail: hostApi + `/notifications/detail`,
        task_summaries: hostApi + `/notifications/task-summary`
    },
    overtime:{
        index: hostApi + `/overtime`,
        add: hostApi + `/overtime`,
        update: hostApi + `/overtime`,
        delete: hostApi + `/overtime`,
        detail: hostApi + `/overtime/detail`,
        status: hostApi + `/overtime/status`,
        approval: hostApi + `/overtime/approval`,
    },
    company:{
        setting_transaction: hostApi + `/company/setting-transactions`
    },
    menu:{
        list: hostApi + `/menu`
    }
}

export  {urlApi}